import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgInfoBlue = (props) => /* @__PURE__ */ _jsx("svg", {
	xmlns: "http://www.w3.org/2000/svg",
	width: 16,
	height: 16,
	viewBox: "0 0 16 16",
	...props,
	children: /* @__PURE__ */ _jsx("g", {
		fill: "none",
		fillRule: "evenodd",
		children: /* @__PURE__ */ _jsx("g", { children: /* @__PURE__ */ _jsx("g", { children: /* @__PURE__ */ _jsxs("g", {
			transform: "translate(-332 -325) translate(276 201) translate(56 124)",
			children: [/* @__PURE__ */ _jsx("rect", {
				width: 15,
				height: 15,
				x: .5,
				y: .5,
				stroke: "#007AFF",
				rx: 7.5
			}), /* @__PURE__ */ _jsx("path", {
				fill: "#007AFF",
				d: "M8 6.25c.414 0 .75.336.75.75v4.5c0 .414-.336.75-.75.75s-.75-.336-.75-.75V7c0-.414.336-.75.75-.75zm0-2.5c.414 0 .75.336.75.75s-.336.75-.75.75-.75-.336-.75-.75.336-.75.75-.75z"
			})]
		}) }) })
	})
});
export default SvgInfoBlue;
